import { Header } from 'semantic-ui-react';
export default Header;